const newFormatDate = (startingDate, type) => {
  const date = new Date(startingDate);
  date.setUTCDate(1);
  date.setUTCMonth(date.getUTCMonth());

  if (type === 'post') {
    date.setUTCHours(23, 59, 0, 0);
  } else if (type === 'get') {
    date.setUTCHours(0, 0, 0, 0);
  }

  return date.getTime();
};

export default newFormatDate;
